namespace $ {
	$mol_style_define( $bog_ui_skeleton, {
		height: '1rem',
		minHeight: '0.25rem',
		maxHeight: '4rem',
		width: '100%',
		borderRadius: '0.5rem',
		background: {
			color: $mol_theme.card,
		},
		flex: {
			shrink: 0,
		},
	} )
}
